import React from 'react';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

import styles from './Landing.module.scss';
import LoginForm from './LoginForm';

const Landing = () => {
  const { assets, siteName } = useConfigStore((s) => s.config);
  const banner = assets.banner;

  return (
    <div className={styles.container}>
      <title>{siteName}</title>
      <header className={styles.header}>
        <h1 className={styles.logo}>{banner && <img className={styles.banner} src={banner} alt="Stream-IQ logo" />}</h1>
      </header>

      <main className={styles.hero}>
        <div className={styles.heroContent}>
          <img className={styles.vdLogo} src="https://framerusercontent.com/images/ReXRv0yv79kjiHxqTobSkrCzmaw.svg?scale-down-to=1024" alt="Videodock logo" />
          <h2>Unlimited movies, TV shows, and more.</h2>
          <p>Watch anywhere. Cancel anytime.</p>
          <LoginForm />
        </div>
      </main>
    </div>
  );
};

export default Landing;
